<template>
  <div class="DoorMapping">
    <ATable
      ref="table"
      :data="items"
      :placeholder="placeholder"
      :search_field="search_field"
      :disable_insert="!has_grant_write"
      border
      hide-pagination
      @cell-click="handleCellClick"
      @clicked-create="handleClickedCreate"
    >
      <el-table-column
        type="index"
        label="No"
        align="center"
        prop="index"
        :width="$width.index"
        :index="handleIndex"
      />
      <el-table-column prop="product_id" label="품목" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <ASelector v-model="scope.row.product_id" :items="door_products" />
          </div>
          <div v-else>
            {{ scope.row.product_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="door_color_id" label="색상">
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <ASelector
              v-model="scope.row.door_color_ids"
              v-bind:class="{ 'readonly-noborder': scope.row.id !== editingId }"
              class="w-full"
              :items="table_door_color"
              multiple
            />
          </div>
          <div v-else>
            {{ scope.row.door_color_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="명령" width="150">
        <template slot-scope="scope">
          <div v-show="scope.row.id === editingId">
            <el-button
              type="primary"
              size="mini"
              :disabled="!has_grant_write"
              :loading="load_button"
              @click="handleClickRegister(scope.row)"
              >저장</el-button
            >
            <el-button size="mini" @click="calcelEditing(scope.row)"
              >취소</el-button
            >
          </div>
          <div v-show="scope.row.id !== editingId">
            <el-button
              type="danger"
              size="mini"
              :disabled="!has_grant_write"
              :loading="load_button"
              @click="handleClickDelete(scope.row)"
              >삭제</el-button
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_user_name"
        :label="$t('lang.created_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="modified_user_name"
        :label="$t('lang.modified_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="created_at"
        :label="$t('lang.created_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
      <el-table-column
        prop="modified_at"
        :label="$t('lang.modified_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
    </ATable>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { base_data } from "@/common/mixins/base_data";

export default {
  name: "DoorMapping",
  mixins: [base_data],
  data() {
    return {
      title: this.$t("title.door_mapping"),
      placeholder: "품목, 색상",
      search_field: ["product_name", "door_color_name"],
      items: [],
      editingId: -1,
      oldItem: undefined,
      deleteData: undefined,
      base_data: ["table_product_door_color_price"],
      load_button: false,
    };
  },
  props: {
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      "table_product",
      "table_door_color",
      "table_product_door_color_price",
    ]),
    door_products: function() {
      return this.table_product.filter((p) => p.kind === "DOOR");
    },
  },
  mounted() {
    this.init();
  },
  destroyed() {
    if (this.editingId < 0) {
      return;
    }
    this.calcelEditing(this.oldItem);
    this.editingId = -1;
  },
  methods: {
    init() {
      this.items = this.initItems();
    },
    initItems() {
      let items = [];
      this.table_product_door_color_price.forEach((e) => {
        let item = items.find((item) => item.product_id === e.product_id);
        if (item) {
          item.door_color_ids.push(e.door_color_id);
          if (e.modified_at > item.modified_at) {
            item.modified_user_name = e.modified_user_name;
            item.modified_at = e.modified_at;
          }
        } else {
          let product = this.table_product.find((p) => p.id === e.product_id);
          item = {
            id: e.id,
            product_id: e.product_id,
            product_name: product?.name,
            door_color_ids: [e.door_color_id],
            created_user_name: e.created_user_name,
            modified_user_name: e.modified_user_name,
            created_at: e.created_at,
            modified_at: e.modified_at,
          };
          items.push(item);
        }
      });
      //두께를 숫자별로 정렬
      items.forEach((item) => {
        item.door_color_name = "";
        item.door_color_ids.forEach((id) => {
          let color = this.table_door_color.find((t) => t.id === id);
          if (items.door_color_name !== " ") {
            item.door_color_name += " " + color?.name;
          } else {
            item.door_color_name += color?.name;
          }
        });
      });
      return items;
    },
    calcelEditing(data) {
      let index = this.items.findIndex((i) => i.id === data.id);
      if (this.oldItem.id) {
        this.items.splice(index, 1, this.oldItem);
      } else {
        this.items.splice(index, 1);
      }
      this.editingId = -1;
    },
    doDelete() {
      this.load_button = true;
      this.api.deleteProductDoor(this.deleteData).then((res) => {
        this.load_button = false;
        this.handleResult(res, this.$t("message.success_delete"));
      });
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleClickedCreate() {
      if (this.editingId > -1) {
        this.calcelEditing(this.oldItem);
      }
      this.editingId = 0;
      this.oldItem = { id: 0, product_id: null, door_color_ids: [] };
      this.items.push(this.oldItem);
    },
    handleCellClick(item, column) {
      if (this.editingId === item.id) {
        return;
      }
      if (this.editingId > -1) {
        this.calcelEditing(this.oldItem);
      }
      if (!column.property) {
        return;
      }
      this.editingId = item.id;
      this.oldItem = Object.assign({}, item);
    },
    handleClickRegister(data) {
      if (!data.product_id) {
        this.util.notify_warning(this, this.title, "품목을 선택해주세요.");
        return;
      }
      if (data.door_color_ids.length < 1) {
        this.util.notify_warning(this, this.title, "색상을 선택해주세요.");
        return;
      }
      let duplicated = this.items.find((item) => {
        return item.id !== data.id && item.product_id === data.product_id;
      });
      if (duplicated) {
        this.util.notify_warning(this, this.title, "중복된 품목입니다.");
        return;
      }
      this.load_button = true;
      this.api.registerProductDoor(data).then((res) => {
        this.load_button = false;
        this.handleResult(res, this.$t("message.success_register"));
      });
    },
    handleClickDelete(data) {
      this.deleteData = data;
      this.util.confirm_delete(
        this,
        this.title + "[" + data.product_name + "]",
        this.doDelete
      );
    },
    handleResult(res, successMessage) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.editingId = -1;
      this.util.notify_success(this, this.title, successMessage);
    },
  },
};
</script>
